module.exports = __webpack_public_path__ + "assets/images/1-2s-y_8a.jpg";